import React from "react";

export function Brand({ compact = false }) {
  return (
    <span className={`brand ${compact ? "brand--compact" : ""}`}>
      <svg className="brand-mark" viewBox="0 0 28 28" aria-hidden="true"><path d="M5 4.5c0-.8.9-1.3 1.6-.8l12 8.3a1.2 1.2 0 0 1 0 2L6.6 22.3c-.7.5-1.6 0-1.6-.8V4.5Z"/><path d="m19.8 8.2 4.3 5-4.3 5"/></svg>
      <span className="brand-name">Theo<span>Fast</span></span>
    </span>
  );
}
